import React from 'react';

import classes from './TitledImage.module.scss';
import InBodyScaleImage from '../../../../../../../../assets/images/scan-iq-customer-management/bg-inbody-scale.png';

const TitledImage = () => {
  return (
    <div className={classes.container}>
      <img className={classes.image} src={InBodyScaleImage} alt="inbody scale" />
      <div className={classes.gradientMask} />
      <p className={classes.title}>
        Unlock your body’s profile:
        <br />
        muscle, fat, hydration, metabolism —
        <span className={classes.accentSpan}>revealed in minutes.</span>
      </p>
    </div>
  );
};

export { TitledImage };
